import React from 'react'
import { useTranslation } from 'react-i18next'
import Cruise from '../types/Cruise'
import CruiseInfoWindow from './CruiseInfoWindow'

type Props = {
  visible: boolean

  cruise: Cruise | null

  hideLayer: () => void
}

const CruiseLayer: React.FC<Props> = ({ visible, cruise, hideLayer }: Props) => {
  const { t } = useTranslation()

  if (visible && cruise) {
    return (
      <div className='container cruise--layer'>
        <div className='cruise--opacity'></div>
        <div className='cruise--view'>
          <CruiseInfoWindow cruise={cruise} />
          <div className='cruise--discover text text--size14 text--white text--center'>
            {t('cruise.discover')}
          </div>
          <div className='cruise--begin' onClick={hideLayer}>
            <div className='text text--white button--dark text--size14'>
              {t('cruise.begin')}
            </div>
          </div>
        </div>
      </div>
    )
  }
  return null
}

export default CruiseLayer
